import { useState, useEffect } from 'react';
import { getPromptById } from '../../../../services';
import { useStore } from '../../../../hooks';


export function usePromptTitle(promptId, initialName = '') {
  const [name, setName] = useState(initialName);
  const isNew = promptId === 'new' || !promptId;
  const { authStore } = useStore();
  const tenantId = authStore.selectedAccount.id
  useEffect(() => {
    if (isNew || initialName) return;               
    getPromptById({ id: promptId, tenantId })
      .then(res => setName(res.data.name))
      .catch(() => setName('Prompt'));      
  }, [promptId, isNew, initialName]);

  return isNew ? 'New Prompt' : name || '…';
}
